import React from 'react';

const ThankYou = () => {
  return (
    <div className="author-page-thanks">
      <section className="author-hero-thanks">
        <div className="hero-content-thanks">
          <h1>Thank you!</h1>
          <p>We’ve received your submission and will be in touch shortly to schedule your call. We can’t wait to help you build your dream website.</p>
          <a href="/authors" className="author-hero-thanks-btn">Back to home</a>
        </div>
      </section>
    </div>
  );
};

export default ThankYou;